import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4a27892f&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4a27892f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a27892f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a27892f')) {
      api.createRecord('4a27892f', component.options)
    } else {
      api.reload('4a27892f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4a27892f&scoped=true&", function () {
      api.rerender('4a27892f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/components/integral/userDetail/index.vue"
export default component.exports